import { fromJS } from 'immutable';

import {
  GET_QUESTIONS_SECRETS,
  SET_QUESTIONS_SECRETS,
  SET_PASSWORD_RECOVERY_STEP,
  SUBMIT_PASSWORD_RECOVERY_STEP,
  SUBMIT_PASSWORD_RECOVERY_STEP_SUCCESS,
  SUBMIT_PASSWORD_RECOVERY_STEP_FAIL,
  SET_LOGIN_RECOVERY_STEP,
  SUBMIT_LOGIN_RECOVERY_STEP,
  SUBMIT_LOGIN_RECOVERY_STEP_SUCCESS,
  SUBMIT_LOGIN_RECOVERY_STEP_FAIL,
  SET_TOKEN_CREDENTIALS,
  CHANGE_PASSWORD_FAIL,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_SECRET_QUESTION,
  CHANGE_SECRET_QUESTION_FAIL,
  CHANGE_SECRET_QUESTION_SUCCESS,
  ENABLE_NOTIFICATIONS,
  ENABLE_NOTIFICATIONS_SUCCESS,
  ENABLE_NOTIFICATIONS_FAIL,
} from 'store/credentials/constants';

import { FORGOT_PASSWORD_LOGIN } from 'containers/PasswordRecoveryPages/constants';
import { INSERT_INFOS } from 'containers/LoginRecoveryPage/constants';
import { CredentialsActionType } from 'store/credentials/actions';

export const initialState = fromJS({
  questionSecret: [],
  isLoadingQuestion: false,
  isLoading: false,
  errorMessageGetQuestion: null,
  errorMessage: null,
  currentPasswordRecoveryStepName: FORGOT_PASSWORD_LOGIN,
  isLoadingPassRecov: false,
  currentLoginRecoveryStepName: INSERT_INFOS,
  isLoadingLoginRecovery: false,
  errorMessageLoginRecovery: null,
  hashedEmail: '',
  isQuestion: null,
  isEmail: null,
  token: null,
  isLoadingChangePassword: false,
  isLoadingChangeSecretQuestion: false,
  isLoadingNotficationEnabled: false,
});
export default function reducer(
  state = initialState,
  action: CredentialsActionType,
) {
  switch (action.type) {
    case GET_QUESTIONS_SECRETS:
      return state
        .set('isLoadingQuestion', true)
        .set('errorMessageGetQuestion', null);
    case SET_QUESTIONS_SECRETS:
      return state
        .set('questionSecret', action.payload)
        .set('isLoadingQuestion', false)
        .set('errorMessage', null);
    case SUBMIT_PASSWORD_RECOVERY_STEP:
      return state.set('isLoadingPassRecov', true);
    case SUBMIT_PASSWORD_RECOVERY_STEP_SUCCESS:
      return state.merge(action.payload, { isLoadingPassRecov: false });
    case SUBMIT_PASSWORD_RECOVERY_STEP_FAIL:
      return state
        .set('errorMessage', action.payload)
        .set('isLoadingPassRecov', false);
    case SET_PASSWORD_RECOVERY_STEP:
      return state
        .set('currentPasswordRecoveryStepName', action.payload)
        .set('isLoadingPassRecov', false)
        .set('errorMessage', null);
    case SUBMIT_LOGIN_RECOVERY_STEP:
      return state.set('isLoadingLoginRecovery', true);
    case SUBMIT_LOGIN_RECOVERY_STEP_SUCCESS:
      return state.merge(action.payload, { isLoadingLoginRecovery: false });
    case SUBMIT_LOGIN_RECOVERY_STEP_FAIL:
      return state
        .set('errorMessageLoginRecovery', action.payload)
        .set('isLoadingLoginRecovery', false);
    case SET_LOGIN_RECOVERY_STEP:
      return state
        .set('currentLoginRecoveryStepName', action.payload)
        .set('isLoadingLoginRecovery', false);
    case SET_TOKEN_CREDENTIALS:
      return state.set('token', action.payload);
    case CHANGE_PASSWORD:
      return state.set('isLoadingChangePassword', true);
    case CHANGE_PASSWORD_SUCCESS:
      return state.set('isLoadingChangePassword', false);
    case CHANGE_PASSWORD_FAIL:
      return state.set('isLoadingChangePassword', false);
    case CHANGE_SECRET_QUESTION:
      return state.set('isLoadingChangeSecretQuestion', true);
    case CHANGE_SECRET_QUESTION_SUCCESS:
      return state.set('isLoadingChangeSecretQuestion', false);
    case CHANGE_SECRET_QUESTION_FAIL:
      return state.set('isLoadingChangeSecretQuestion', false);
    case ENABLE_NOTIFICATIONS:
      return state.set('isLoadingNotficationEnabled', true);
    case ENABLE_NOTIFICATIONS_SUCCESS:
      return state.set('isLoadingNotficationEnabled', false);
    case ENABLE_NOTIFICATIONS_FAIL:
      return state.set('isLoadingNotficationEnabled', false);
    default:
      return state;
  }
}
